import React from "react";

interface DeleteProps {
    color?: string;
    width?: string;
    height?: string;
}

export default function Delete({ color = "#000000", width = "38px", height = "38px" }: DeleteProps) {
    return (
        <div className="d-flex justify-content-center align-items-center">
            <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 5H18M9 5V5C10.5769 3.16026 13.4231 3.16026 15 5V5M9 20H15C16.1046 20 17 19.1046 17 18V9C17 8.44772 16.5523 8 16 8H8C7.44772 8 7 8.44772 7 9V18C7 19.1046 7.89543 20 9 20Z" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
}
